import { ModelBase } from "./ModelBase.js";
import pointInPolygon from "point-in-polygon";
import { Zone } from "./Zone.js";
import { SensorReadingConfiguration } from "verdi-common/schemas/sensorReadingConfiguration/sensorReadingConfiguration";

export class AreaOfInterest extends ModelBase {
    checkForRecentData = true;
    /**
     * Every vertices in coordinates for mapping purposes
     * @type {{lat, lng}[]}
     */
    polygon = [];

    zonesInArea: Zone[] = [];
    verdiId?: string;
    sensorReadingConfiguration: SensorReadingConfiguration = {
        schemaKey: SensorReadingConfiguration.schemaKey,
        configurationBySensorType: {},
        customRules: [],
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(json: any) {
        super(json);
        this.category = "aoi";
        this.dbID = json._id || json.id;
        this.loadFromJSON(json);
        this.load().catch((e) => {
            console.warn(e);
        });
    }
    getJSON() {}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    loadFromJSON(json: any) {
        this._lastJSON = json;
        this.verdiId = json.verdiId ?? this.verdiId;
        this.name = json.name || json.label;
        this.owner = json.owner;
        this.sensorReadingConfiguration = json.sensorReadingConfiguration ?? this.sensorReadingConfiguration;
        if (json.polygons) {
            this.polygon = json.polygons[0];
        } else if (json.vertices) {
            this.polygon = json.vertices[0];
        }
    }

    containsPoint(lat: number, lng: number) {
        const transformedBoundaries = this.polygon.map((p) => [p.lat, p.lng]);
        const point = [lat, lng];
        return pointInPolygon(point, transformedBoundaries);
    }
}
